import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

/* Types & Action Creators */
export const { Types, Creators } = createActions({
  toggleReactPrettyAlert: [
    "type",
    "open",
    "title",
    "message",
    "stacktrace",
    "buttons"
  ]
});

/* Initial State */
const INITIAL_STATE = Immutable({
  type: "default",
  open: false,
  title: "",
  message: "",
  stacktrace: null,
  buttons: []
});

/* Reducers */
const toggle = (state = INITIAL_STATE, action) => ({
  ...INITIAL_STATE,
  ...action.properties
});

/* Reducers to types */
export default createReducer(INITIAL_STATE, {
  [Types.TOGGLE_REACT_PRETTY_ALERT]: toggle
});
